module.exports = __webpack_public_path__ + "static/Cover_FAQ_Barn_4_Eng-956d89cf89db277f148dcf46b65aab24.svg";